// NOTE: 구매 이벤트 스크립트
const collect = () => {
  try {
    if (!window.karrotPixel || !window.karrotPixel.trackerId) return
    window.karrotPixel.track('Purchase')
  } catch (error) {
    const daagnScriptError = error as Error
    window.DD_LOGS?.logger.warn(daagnScriptError.message, undefined, daagnScriptError)
    window.Rollbar?.warning(daagnScriptError.message, daagnScriptError)
  }
}

export default collect
